define("calendar/components/calendar/stories/sortable-item", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/object/computed", "@ember/utils", "later/utils/time-format", "@ember-decorators/component"], function (_exports, _component, _templateFactory, _component2, _object, _computed, _utils, _timeFormat, _component3) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/object/computed",0,"@ember/utils",0,"later/utils/time-format",0,"@ember-decorators/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li class="cSE--gallery__item" data-test-id="media-item-{{@item.id}}" data-item-id={{this.uniqueId}}>
    <figure class="o--mediaContainer cSE--gallery__mediaContainer">
      <span class={{if this.isInvalidVideoLength "cSE--gallery__meta" "cSE--gallery__drag"}}>
        {{#if this.isVideo}}
          {{#if this.isInvalidVideoLength}}
            <p class="u--p__b__0 u--text--white">
              {{svg-jar "danger-solid" class="o--icon o--icon--white u--m__l__xs"}}
              <span class="cSE--gallery__metaText">
                {{t "stories.story_editor.trim_video_length"}}
              </span>
            </p>
          {{else}}
            <span class="cSE--gallery__icon--time">
              {{this.formattedDuration}}
            </span>
          {{/if}}
        {{else}}
          <span class="cSE--gallery__icon--time">
            {{this.formattedStoryDurationInSeconds}}
          </span>
        {{/if}}
        {{#unless this.isInvalidVideoLength}}
          <span class="cSE--gallery__icon--drag">
            {{svg-jar "move" class="o--icon o--icon--white"}}
          </span>
        {{/unless}}
      </span>
      <img src={{@item.previewUrl}} class="o--media cSE--gallery__media" />
      <b class="o--mediaOverlay"></b>
      {{#if this.isVideo}}
        <span class="cSE--gallery__icon--type">
          {{svg-jar "play" class="o--icon--lg o--icon--white"}}
        </span>
      {{/if}}
      {{#if this.canCrop}}
        <span class="cSE--gallery__mediaStatus" {{action "editPMICrop"}}>
          {{svg-jar "edit" class="o--icon--sm o--icon--white u--m__r__xs"}}
          <span>
            {{t "shared_words.edit"}}
          </span>
        </span>
      {{/if}}
      {{#if @canDeleteStoryItems}}
        <span class="cSE--gallery__icon--delete" data-test-id="delete-button-{{@item.id}}" {{action "removeStoryItem"}}>
          {{svg-jar "close" class="o--icon--sm o--icon--white"}}
        </span>
      {{/if}}
    </figure>
  </li>
  
  */
  {
    "id": "DgW1gWBX",
    "block": "[[[10,\"li\"],[14,0,\"cSE--gallery__item\"],[15,\"data-test-id\",[29,[\"media-item-\",[30,1,[\"id\"]]]]],[15,\"data-item-id\",[30,0,[\"uniqueId\"]]],[12],[1,\"\\n  \"],[10,\"figure\"],[14,0,\"o--mediaContainer cSE--gallery__mediaContainer\"],[12],[1,\"\\n    \"],[10,1],[15,0,[52,[30,0,[\"isInvalidVideoLength\"]],\"cSE--gallery__meta\",\"cSE--gallery__drag\"]],[12],[1,\"\\n\"],[41,[30,0,[\"isVideo\"]],[[[41,[30,0,[\"isInvalidVideoLength\"]],[[[1,\"          \"],[10,2],[14,0,\"u--p__b__0 u--text--white\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"danger-solid\"],[[\"class\"],[\"o--icon o--icon--white u--m__l__xs\"]]]],[1,\"\\n            \"],[10,1],[14,0,\"cSE--gallery__metaText\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"stories.story_editor.trim_video_length\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,1],[14,0,\"cSE--gallery__icon--time\"],[12],[1,\"\\n            \"],[1,[30,0,[\"formattedDuration\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]]],[]],[[[1,\"        \"],[10,1],[14,0,\"cSE--gallery__icon--time\"],[12],[1,\"\\n          \"],[1,[30,0,[\"formattedStoryDurationInSeconds\"]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[41,[51,[30,0,[\"isInvalidVideoLength\"]]],[[[1,\"        \"],[10,1],[14,0,\"cSE--gallery__icon--drag\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"move\"],[[\"class\"],[\"o--icon o--icon--white\"]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n    \"],[10,\"img\"],[15,\"src\",[30,1,[\"previewUrl\"]]],[14,0,\"o--media cSE--gallery__media\"],[12],[13],[1,\"\\n    \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n\"],[41,[30,0,[\"isVideo\"]],[[[1,\"      \"],[10,1],[14,0,\"cSE--gallery__icon--type\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"play\"],[[\"class\"],[\"o--icon--lg o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"canCrop\"]],[[[1,\"      \"],[11,1],[24,0,\"cSE--gallery__mediaStatus\"],[4,[38,4],[[30,0],\"editPMICrop\"],null],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"edit\"],[[\"class\"],[\"o--icon--sm o--icon--white u--m__r__xs\"]]]],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"shared_words.edit\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,2],[[[1,\"      \"],[11,1],[24,0,\"cSE--gallery__icon--delete\"],[16,\"data-test-id\",[29,[\"delete-button-\",[30,1,[\"id\"]]]]],[4,[38,4],[[30,0],\"removeStoryItem\"],null],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"close\"],[[\"class\"],[\"o--icon--sm o--icon--white\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@item\",\"@canDeleteStoryItems\"],false,[\"if\",\"svg-jar\",\"t\",\"unless\",\"action\"]]",
    "moduleName": "calendar/components/calendar/stories/sortable-item.hbs",
    "isStrictMode": false
  });

  let SortableItemComponent = (_dec = (0, _component3.tagName)(''), _dec2 = (0, _computed.reads)('args.item.uniqueId'), _dec3 = (0, _computed.reads)('args.item.isImage'), _dec4 = (0, _computed.reads)('args.item.isVideo'), _dec5 = (0, _computed.reads)('args.item.videoDuration'), _dec6 = (0, _computed.reads)('args.item.storySecondDuration'), _dec7 = (0, _computed.reads)('args.item.mediaItem'), _dec8 = (0, _computed.or)('isImage', 'isVideo'), _dec9 = (0, _object.computed)('mediaItem', 'groupId', 'mediaGroupId'), _dec10 = (0, _object.computed)('canCropOnPost', 'isValidMediaTypeForCrop', 'mediaOnSameGroup', 'mediaItem.active'), _dec11 = (0, _object.computed)('isVideo', 'videoDuration', 'storyVideoMaxLength'), _dec12 = (0, _object.computed)('videoDuration'), _dec13 = (0, _object.computed)('storySecondDuration'), _dec(_class = (_class2 = class SortableItemComponent extends _component2.default {
    get mediaOnSameGroup() {
      return !(0, _utils.isNone)(this.mediaItem) && this.args.groupId === this.mediaGroupId;
    }

    get canCrop() {
      return this.args.canCropOnPost && this.isValidMediaTypeForCrop && this.mediaOnSameGroup && this.mediaItem.get('active');
    }

    get isInvalidVideoLength() {
      const hasInvalidVideoLength = this.args.storyVideoMaxLength && this.videoDuration * 1000 > this.args.storyVideoMaxLength;
      return Boolean(this.isVideo && hasInvalidVideoLength);
    }

    get formattedDuration() {
      // Note: use floor to be consistent with HTML player
      return (0, _timeFormat.timeFormat)(Math.floor(this.videoDuration));
    }

    get formattedStoryDurationInSeconds() {
      return (0, _timeFormat.timeFormat)(Math.floor(this.storySecondDuration));
    }

    constructor(owner, args) {
      var _this$mediaItem, _this$mediaItem$get;

      super(owner, args);

      _defineProperty(this, "mediaGroupId", '');

      _initializerDefineProperty(this, "uniqueId", _descriptor, this);

      _initializerDefineProperty(this, "isImage", _descriptor2, this);

      _initializerDefineProperty(this, "isVideo", _descriptor3, this);

      _initializerDefineProperty(this, "videoDuration", _descriptor4, this);

      _initializerDefineProperty(this, "storySecondDuration", _descriptor5, this);

      _initializerDefineProperty(this, "mediaItem", _descriptor6, this);

      _initializerDefineProperty(this, "isValidMediaTypeForCrop", _descriptor7, this);

      (0, _object.set)(this, 'mediaGroupId', this.mediaItem ? (_this$mediaItem = this.mediaItem) === null || _this$mediaItem === void 0 ? void 0 : (_this$mediaItem$get = _this$mediaItem.get('group')) === null || _this$mediaItem$get === void 0 ? void 0 : _this$mediaItem$get.get('id') : null);
    }

    editPMICrop() {
      if (this.args.item && this.canCrop) {
        this.args.editPMICrop(this.args.item);
      }
    }

    removeStoryItem() {
      if (!this.args.item) {
        return;
      }

      this.args.removeStoryItem(this.args.item);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "uniqueId", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "isImage", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "isVideo", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "videoDuration", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "storySecondDuration", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "mediaItem", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "isValidMediaTypeForCrop", [_dec8], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "mediaOnSameGroup", [_dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "mediaOnSameGroup"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canCrop", [_dec10], Object.getOwnPropertyDescriptor(_class2.prototype, "canCrop"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isInvalidVideoLength", [_dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "isInvalidVideoLength"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "formattedDuration", [_dec12], Object.getOwnPropertyDescriptor(_class2.prototype, "formattedDuration"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "formattedStoryDurationInSeconds", [_dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "formattedStoryDurationInSeconds"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "editPMICrop", [_object.action], Object.getOwnPropertyDescriptor(_class2.prototype, "editPMICrop"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeStoryItem", [_object.action], Object.getOwnPropertyDescriptor(_class2.prototype, "removeStoryItem"), _class2.prototype)), _class2)) || _class);
  _exports.default = SortableItemComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SortableItemComponent);
});